import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border-light">
      <div className="container-custom py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="logo-text mb-4">GPS METHOD™</h3>
            <p className="body-small">
              A system for psychological presence.
              Founded by Mel Masry.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="heading-6 mb-4 text-primary">Navigation</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/method" className="body-small hover:text-primary transition-colors">
                The Method
              </Link>
              <Link to="/school" className="body-small hover:text-primary transition-colors">
                The School
              </Link>
              <Link to="/founder" className="body-small hover:text-primary transition-colors">
                Founder
              </Link>
              <Link to="/coaching" className="body-small hover:text-primary transition-colors">
                Private Coaching
              </Link>
              <Link to="/pathways" className="body-small hover:text-primary transition-colors">
                Professional Pathways
              </Link>
            </nav>
          </div>

          {/* Location */}
          <div>
            <h4 className="heading-6 mb-4 text-primary">Practice</h4>
            <p className="body-small">
              International Practice<br />
              United Kingdom<br />
              Egypt
            </p>
            <a
              href="https://instagram.com/gps1way"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 body-small hover:text-primary transition-colors"
              data-testid="instagram-link"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              @gps1way
            </a>
          </div>
        </div>

        <div className="border-t border-border-light mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="caption">
              © {new Date().getFullYear()} GPS Method™. All rights reserved.
            </p>
            <p className="caption">
              Method Director: Mel Masry
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;